import { QueryFunction, useQueries } from '@tanstack/react-query';
import { useWeb3Context, Web3Context } from '../web3Context';
import { parseAllQueryData } from '@silo/query';
import { BigIntWithDecimals, ChecksumAddress, NATIVE_CURRENCY_DECIMALS } from '@silo/types';

export const assetPriceKey = 'assetPrice';

type AssetPriceKey = readonly [key: typeof assetPriceKey, web3Context: Web3Context, assetAddress: ChecksumAddress];

const queryAssetPrice: QueryFunction<BigIntWithDecimals, AssetPriceKey> = async ({ queryKey }) => {
  const [, { contracts }, assetAddress] = queryKey;

  const price = await contracts.priceProvidersRepository.getPrice(assetAddress);

  return { value: price.toBigInt(), decimals: NATIVE_CURRENCY_DECIMALS };
};

export type AssetPriceMap = Map<ChecksumAddress, BigIntWithDecimals | undefined>;

/**
 * @deprecated - use `useQueryAssetPrices` instead
 */
export const useQueryAssetPriceMap = (assetAddresses: ChecksumAddress[]) => {
  const web3Context = useWeb3Context();

  const queries = useQueries({
    queries: assetAddresses.map((assetAddress) => ({
      queryKey: [assetPriceKey, web3Context!, assetAddress] as const,
      queryFn: queryAssetPrice,
      enabled: !!web3Context,
    })),
  });

  const assetPrices: AssetPriceMap = new Map(assetAddresses.map((assetAddress, i) => [assetAddress, queries[i].data]));

  return assetPrices;
};

export const useQueryAssetPrices = (assetAddresses: ChecksumAddress[], enabled = true) => {
  const web3Context = useWeb3Context();

  const queries = useQueries({
    queries: assetAddresses.map((assetAddress) => ({
      queryKey: [assetPriceKey, web3Context!, assetAddress] as const,
      queryFn: queryAssetPrice,
      enabled: !!web3Context && enabled,
    })),
  });

  return { queries, allData: parseAllQueryData(queries) };
};
